module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASBJREFUeNp80k0rRFEcx/H/va6lyI7koYSdJUki2c0L8BrmHcxuVlOytLBRvAQ7xZqysSJRFDbKUyMLi5l7fY9+R3/jjlufezr/zu+ep2tFURziA/fYwCAMmZhMYBvHmA6Fy+L3c4E5FxhAA+/Yx2Som2ao48mFX7GMNdyoVnUfS811xrGLlgZ+oo1bLMSAlp+W7aXmZs6xonqPG/snuIQrhdpqw2H0ISkLhnYVTXdAizhVf6tj1p89zuPNHcys6kM4U73irimNp3rt9rXuvh7aUTzonvu15O/gpgvtlRxEXFGu+wz9JLweFXrBSMdf48NVHdhY/AHivdW7hDK37APsxOARzrXXpEswc//rCWbCwGEz68UdUvv/yTGF5y8BBgDsaWhta+dV/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/delete_white_icon.png
// module id = 1001
// module chunks = 462